import * as constants from '@/common/constants';

export default {
  methods: {
    /**
     * Append current trackingCode and current testLevel if exists to URL.
     * @param url URL without query string
     * @return {string} URL with query string append
     */
    appendQueryParamsBeforeRedirection(url) {
      // Tracking code, mandatory
      let queryString;
      if (url.includes('?')) {
        queryString = '&trackingCode=' + this.trackingCode;
      } else {
        queryString = '?trackingCode=' + this.trackingCode;
      }

      if (this.externalPartnerId) {
        queryString += '&externalPartnerId=' + this.externalPartnerId;
      }

      // Mindbaz params, mandatory
      queryString += '&base=' + this.mbParams.base;
      queryString += '&campaignId=' + this.mbParams.campaignId;
      queryString += '&shootId=' + this.mbParams.shootId;
      queryString += '&segmentId=' + this.mbParams.segmentId;

      // Marketing cloud params, mandatory
      queryString += '&d=' + this.marketingCloudParams.marketingCloudDataSourceName;
      queryString += '&j=' + this.marketingCloudParams.marketingCloudJobId;
      queryString += '&l=' + this.marketingCloudParams.marketingCloudListId;
      queryString += '&b=' + this.marketingCloudParams.marketingCloudBatchId;
      queryString += '&sk=' + this.marketingCloudParams.marketingCloudSk;
      queryString += '&senddate=' + this.marketingCloudParams.marketingCloudSendDate;

      if (this.journeyConfig.orderFormType === constants.ORDER_FORM_TYPE_1CLICK || (this.$cookies.get('ONECLICK_CONTEXT'))) {
        // SfId, for 1click order forms with salesforce customers
        if (this.sfId) {
          queryString += '&sfId=' + this.sfId;
        }
      }

      if (this.walletUid) {
        queryString += '&walletId=' + this.walletUid;
      }

      // Campaign code, optional
      if (this.campaignCode) {
        queryString += '&campaignCode=' + this.campaignCode;
      }

      // Test Level, optional
      if (this.testLevel) {
        queryString += '&testLevel=' + this.testLevel;
      }

      if (this.leadTrackingCode) {
        queryString += '&leadTrackingCode=' + this.leadTrackingCode;
      }

      return url + queryString;
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/mixins/url-generator.js